import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Button, Grid, GridItem, Typography } from 'seagull';
import BankSecurityRow from '~/components/BankSecurityRow/BankSecurityRow';
import ManagePaymentMethods from '~/components/ManagePaymentMethods/ManagePaymentMethods';
import { useStore } from '~/contexts';
import { useRequestPM } from '~/hooks/useRequestPaymentMethod';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { relationshipModel } from '~/models';
import StripeElementsProvider from '~/providers/StripeElementsProvider';
import { selectors } from '~/store/state-selectors';
import MinisiteTabHeader from '../MinisiteTabHeader/MinisiteTabHeader';
import styles from './PaymentMethods.module.scss';
export default function PaymentMethods(props) {
    const { isVendor, agreement, onRefreshAgreement } = props;
    const { t } = useLocaleKeys('pages.agreementMinisite');
    const isAccountant = useStore(selectors.user.isAccountant);
    const requestPm = useRequestPM();
    const [isAddingAnotherPaymentMethod, setIsAddingAnotherPaymentMethod] = useState(false);
    const isAdHoc = relationshipModel.isAdHoc(agreement);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MinisiteTabHeader, {
                testId: "payment-methods-page-header",
                text: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        t.paymentMethodsTitle(),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph2",
                            children: t.paymentMethods.manage()
                        })
                    ]
                }),
                actions: /*#__PURE__*/ _jsxs("div", {
                    className: styles.actionButtonsContainer,
                    children: [
                        isVendor && !isAdHoc && /*#__PURE__*/ _jsx(Button, {
                            skin: 'primaryOutlineOpaque',
                            testId: 'request-payment-method-btn',
                            intent: Intent.ManagePaymentMethod,
                            onClick: ()=>requestPm(agreement.id),
                            bi: {
                                name: 'request_payment_method'
                            },
                            children: t.requestPaymentMethod()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            skin: "primary",
                            testId: "add-payment-method-btn",
                            intent: Intent.AddPaymentMethod,
                            onClick: ()=>setIsAddingAnotherPaymentMethod(true),
                            bi: {
                                name: 'add_payment_method'
                            },
                            children: t.addPaymentMethod()
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Grid, {
                children: [
                    !relationshipModel.isTerminated(agreement) && /*#__PURE__*/ _jsx(GridItem, {
                        span: 12,
                        children: /*#__PURE__*/ _jsx(StripeElementsProvider, {
                            children: /*#__PURE__*/ _jsx(ManagePaymentMethods, _object_spread({
                                isAddingAnotherPaymentMethod: isAddingAnotherPaymentMethod,
                                setIsAddingAnotherPaymentMethod: setIsAddingAnotherPaymentMethod,
                                isVendorCoveringFees: relationshipModel.actualIsVendorCoveringCCFee(agreement),
                                vendorId: relationshipModel.vendor(agreement),
                                customerId: relationshipModel.customer(agreement),
                                showCreditCardFee: !relationshipModel.actualIsVendorCoveringCCFee(agreement),
                                isProposal: false,
                                isPreview: false,
                                isSample: relationshipModel.isSample(agreement),
                                hideInviteMemberHint: isVendor,
                                isInviteMemberDisabled: isAccountant || relationshipModel.isSample(agreement),
                                relationshipId: relationshipModel.id(agreement),
                                onPaymentMethodUpdated: ()=>onRefreshAgreement({
                                        silent: true
                                    }),
                                hideExpandableAddPmButton: true,
                                isAdHoc: isAdHoc
                            }, props))
                        })
                    }),
                    /*#__PURE__*/ _jsx(GridItem, {
                        span: 12,
                        children: /*#__PURE__*/ _jsx(BankSecurityRow, {})
                    })
                ]
            })
        ]
    });
}
